import React from 'react';

import './Footer.scss';

type FooterProps = {
  ref?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>['ref'];
  children: React.ReactNode;
  actions?: React.ReactNode;
};

export const Footer: React.FC<FooterProps> = ({ ref, actions, children }) => {
  return (
    <div ref={ref} className="widget-footer">
      {actions && <div className="widget-footer__actions">{actions}</div>}
      {children}
    </div>
  );
};
